var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApkDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 35a1.993 1.993 0 0 1-1.414-.586l-8-8a2 2 0 1 1 2.828-2.828L24 30.172l6.586-6.586a2 2 0 1 1 2.828 2.828l-8 8A1.994 1.994 0 0 1 24 35z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34a2 2 0 0 1-2-2V8a2 2 0 0 1 4 0v24a2 2 0 0 1-2 2z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 42H12a6.007 6.007 0 0 1-6-6v-2a2 2 0 0 1 4 0v2a2.002 2.002 0 0 0 2 2h24a2.003 2.003 0 0 0 2-2v-2a2 2 0 0 1 4 0v2a6.007 6.007 0 0 1-6 6z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApkDownload);
export default __webpack_public_path__ + "static/media/apk-download.f137b5460f29c5d145d959b6806ba335.svg";
export { ForwardRef as ReactComponent };